import { render, staticRenderFns } from "./ArmsBaseConfidentialLevel.vue?vue&type=template&id=45fbacc3&scoped=true&"
import script from "./ArmsBaseConfidentialLevel.vue?vue&type=script&lang=js&"
export * from "./ArmsBaseConfidentialLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fbacc3",
  null
  
)

export default component.exports